'use client'

// Phase-aware persistent advance affordance for Surface B. Bottom-fixed
// across all viewports, centered within the max-w-2xl column (§11.5 LOCKED
// v1.2 inheritance from Surface A). Vermilion fill — Surface B's single
// at-rest vermilion placement (§7 budget 1/2).
//
// Divergence from Surface A's variant: always a button (Surface B has no
// link-shaped advances — batch-end transitions are owned by the test hook
// via router.push). And no auto-arrow logic: Surface B labels carry their
// own arrows literally — `Submit` (action verb, no arrow) / `Continue →`
// (forward motion, arrow in label). Surface A's auto-arrow would import a
// forward-motion register where the moment is transactional confirmation.

interface Props {
    label: string
    onPress: () => void
    disabled?: boolean
}

export function AdvanceAffordance({ label, onPress, disabled }: Props) {
    return (
        <div className="fixed inset-x-0 bottom-0 z-10 border-t border-rule-soft bg-paper/95 bg-linear-to-t from-paper to-transparent px-5 pt-4 pb-safe backdrop-blur-sm md:px-8">
            <div className="mx-auto flex w-full max-w-2xl justify-center">
                <button
                    type="button"
                    onClick={onPress}
                    disabled={disabled}
                    aria-label={label}
                    className="inline-flex h-12 w-full max-w-xs items-center justify-center rounded-sm bg-action font-serif text-base font-medium tracking-wide text-action-on outline-focus-ring transition-colors duration-200 hover:bg-action-hover focus-visible:outline-2 focus-visible:outline-offset-4 active:translate-y-px active:bg-action-pressed disabled:cursor-not-allowed disabled:opacity-60 motion-reduce:transition-none motion-reduce:active:translate-y-0"
                >
                    {label}
                </button>
            </div>
        </div>
    )
}
